import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const changeRequestItemValidate = (payload) => AxiosClient.post('/change-request-item-validation', payload);
const changeRequestItemCreate = (payload) => AxiosClient.post('/change-request-item', payload);
const changeRequestItemUpdate = (payload) => AxiosClient.post('/change-request-item/update', payload);
const changeRequestItemDelete = (payload) => AxiosClient.post('/change-request-item/delete', payload);

export {
    changeRequestItemValidate,
    changeRequestItemCreate,
    changeRequestItemUpdate,
    changeRequestItemDelete
}